export const BUTTON_APPEAR_SCROLL_Y = 1000;
export const THROTTLE_DELAY = 500;
export const SCROLL_BUTTON_BREAKPOINT = 1024;
